import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';
import { useLanguage } from '../../hooks/useLanguage';

const TermsOfSale: React.FC = () => {
    const { t, isRTL } = useLanguage();

    return (
        <LegalPageTemplate
            title={t('termsOfSale.title')}
            lastUpdated={t('termsOfSale.lastUpdated')}
        >
            <div dir={isRTL ? 'rtl' : 'ltr'}>
                <p className={`text-gray-600 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.intro.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.intro.paragraph2')}
                </p>

                {/* Section 1 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section1.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section1.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section1.paragraph2')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('termsOfSale.section1.items.platform')}</li>
                    <li>{t('termsOfSale.section1.items.inspectionCredits')}</li>
                    <li>{t('termsOfSale.section1.items.aiCredits')}</li>
                    <li>{t('termsOfSale.section1.items.tools')}</li>
                    <li>{t('termsOfSale.section1.items.support')}</li>
                </ul>

                {/* Section 2 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.subsection1.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.subsection1.paragraph2')}
                </p>
                <ul className={`list-disc mt-2 text-gray-600 ${isRTL ? 'pr-5 text-right' : 'pl-5 text-left'}`}>
                    <li>{t('termsOfSale.section2.subsection1.items.standardCredits')}</li>
                    <li>{t('termsOfSale.section2.subsection1.items.aiCredits')}</li>
                    <li>{t('termsOfSale.section2.subsection1.items.inspectionManagement')}</li>
                    <li>{t('termsOfSale.section2.subsection1.items.chat')}</li>
                    <li>{t('termsOfSale.section2.subsection1.items.quotes')}</li>
                    <li>{t('termsOfSale.section2.subsection1.items.aiDiagnostic')}</li>
                </ul>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.subsection1.paragraph3')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.subsection2.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section2.subsection2.paragraph2')}
                </p>

                {/* Section 3 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.subsection2.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.subsection2.paragraph2')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.subsection3.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section3.subsection3.paragraph1')}
                </p>

                {/* Section 4 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section4.title')}
                </h2>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section4.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section4.paragraph2')}
                </p>

                {/* Section 5 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section5.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section5.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section5.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section5.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section5.subsection2.paragraph1')}
                </p>

                {/* Section 6 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section6.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section6.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section6.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section6.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section6.subsection2.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section6.subsection3.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section6.subsection3.paragraph1')}
                </p>

                {/* Section 7 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section7.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section7.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section7.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section7.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section7.subsection2.paragraph1')}
                </p>

                {/* Section 8 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section8.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section8.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section8.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section8.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section8.subsection2.paragraph1')}
                </p>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section8.subsection2.paragraph2')}
                </p>

                {/* Section 9 */}
                <h2 className={`text-xl font-semibold text-gray-800 mt-8 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.title')}
                </h2>
                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection1.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection1.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection2.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection2.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection3.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection3.paragraph1')}
                </p>

                <h3 className={`text-lg font-medium text-gray-800 mt-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection4.title')}
                </h3>
                <p className={`text-gray-600 mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('termsOfSale.section9.subsection4.paragraph1')}
                </p>
            </div>
        </LegalPageTemplate>
    );
};

export default TermsOfSale;